import { useQuery } from "react-query";
import axios, { AxiosResponse } from "axios";

type NavLink = {
  url: string;
  title: string;
  classList: string;
};

type NavLayout = {
  container: NavLink[];
  mega_menu: Array<NavLink[]>;
};
type SocialAria = {
  label: string;
};
type SocialLink = {
  url: string;
  target: string;
  aria?: SocialAria;
  icon: string;
};
type FooterLayout = {
  columns: Array<NavLink[]>;
  social: SocialLink[];
};

export type Layout = {
  nav?: NavLayout;
  footer?: FooterLayout;
};

export const useLayout = () => {
  const retrieveLayout = async (): Promise<Layout> => {
    const response: AxiosResponse<Layout> = await axios.get<Layout>(
      process.env.REACT_APP_API_LAYOUT_URL || "",
    );
    return response.data;
  };

  return useQuery<Layout, Error>("layout", retrieveLayout, {
    initialData: {},
    retry: 3,
    refetchOnWindowFocus: false,
  });
};
